import { Inject, Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import {WINDOW} from '../../universal/window/window.service';

const KEY_FACTS_STEP = 'factsStep';
const KEY_IS_DONE = 'isDone';

@Injectable()
export class FactsService {

  constructor(
    @Inject(WINDOW) private window: Window,
  ) {}

  saveStep(step: number, endStep: number) {
    if (this.window.localStorage) {
      try {
        const localStorage = this.window.localStorage;
        localStorage.setItem(KEY_FACTS_STEP, String(step));
        localStorage.setItem(KEY_IS_DONE, String(step >= endStep));
      } catch (error) {
      }
    }
  }

  loadStep(): Observable<number> {
    let step = 0;
    if (this.window.localStorage) {
      try {
        const localStorage = this.window.localStorage;
        step = parseInt(localStorage.getItem(KEY_FACTS_STEP)) || 0;
      } catch (error) {
      }
    }
    return of(step);
  }

  isDone(): Observable<boolean> {
    let isDone = false;
    if (this.window.localStorage) {
      try {
        const localStorage = this.window.localStorage;
        isDone = localStorage.getItem(KEY_IS_DONE) == 'true';
      } catch (error) {
      }
    }
    return of(isDone);
  }
}
